import { createFileRoute, useParams } from "@tanstack/react-router";

import { RevisionsPage } from "./-components/revisions.page";

export const Route = createFileRoute("/_authenticated/org/$orgId/program/$programId/revisions/")({
  component: Page
});

function Page() {
  const { orgId, programId } = useParams({
    from: "/_authenticated/org/$orgId/program/$programId/revisions/"
  });
  return <RevisionsPage orgId={orgId} programId={programId} />;
}
